import React, { useState, useEffect } from 'react';
import Accordion from '../ArticleRendering/Accordion';
import ReactPlayerLoader from '@brightcove/react-player-loader';
import CustomSlider from '../CustomSliderRendering/CustomSlider';
import HtmlRawContainerArticle from '../HtmlRawContainer/HtmlRawContainerArticle';
const AdvancedHtmlEditor = ({ containerObject, templateName, contentId, dataZone }) => {
    const [pageData, setPageData] = useState({} || { components: [] });
    console.log("containerObject", containerObject, templateName, contentId, dataZone);
    const jsonData = containerObject?.attributes?.htmlRawContent;
    const [slideIndex, setSlideIndex] = React.useState(0);
    const [direction, setDirection] = useState("right");
    const [enableTransistion, setEnableTransistion] = useState(false);
    const visibleCols = 3;
    const autoPlayRef = React.useRef(false);
    const maxSlideRef = React.useRef(0);
    const autoPlayIntervalRef = React.useRef(3000);
    const isAnimatingRef = React.useRef(true);
    const isManualRef = React.useRef(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [sliderState, setSliderState] = useState({});
    const [activeTabId, setActiveTabId] = useState(null)

    useEffect(() => {
        if (!autoPlayRef.current) return;
        const interval = setInterval(() => {
            isAnimatingRef.current = true;
            setEnableTransistion(true);
            setSlideIndex(prev => {
                if (prev >= maxSlideRef.current) {
                    return 0;
                }
                return prev + 1;
            });
        }, autoPlayIntervalRef.current);

        return () => clearInterval(interval);
    }, [autoPlayRef.current, maxSlideRef.current]);

    useEffect(() => {
        if (!autoPlayRef.current) return;
        if (slideIndex === maxSlideRef.current) {
            setTimeout(() => {
                setEnableTransistion(false);
                setSlideIndex(0);
            }, 300);
        }
    }, [slideIndex, maxSlideRef.current]);

    useEffect(() => {
        if (!enableTransistion) {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    setEnableTransistion(true);
                });
            });
        }
    }, [enableTransistion]);

    const getSliderState = (id) =>
        sliderState[id] || {
            slideIndex: 0,
            enableTransistion: true,
        };
    const updateSliderState = (id, updates) => {
        setSliderState(prev => ({
            ...prev,
            [id]: {
                ...getSliderState(id),
                ...updates,
            }
        }));
    };

    var parsedData;
    if (jsonData) {
        parsedData = typeof jsonData === "string" ? JSON.parse(jsonData) : jsonData;
    }

    const renderComponent = (component, index) => {
        const maxSlide = component.data.noOfColumns - visibleCols;
        switch (component.type) {
            case 'heading':
                const HeadingTag = component.data.level;
                const alignText = component.data.alignment === "left" ? "start" : component.data.alignment === "right" ? "end" : "center";
                return (
                    <HeadingTag
                        className={`text-${alignText} font-semibold ${component.data.dynamicClassCss || ''}`}
                        style={{
                            color: component.data.color || "inherit",
                            border: component.data.border,
                            borderRadius: component.data.borderRadius,
                            paddingTop: component.data.paddingTop || component.data.paddingVertical,
                            paddingBottom: component.data.paddingBottom || component.data.paddingVertical,
                            paddingLeft: component.data.paddingLeft || component.data.paddingHorizontal,
                            paddingRight: component.data.paddingRight || component.data.paddingHorizontal,
                            marginTop: component.data.marginTop || component.data.marginVertical,
                            marginBottom: component.data.marginBottom || component.data.marginVertical,
                            marginLeft: component.data.marginLeft || component.data.marginHorizontal,
                            marginRight: component.data.marginRight || component.data.marginHorizontal
                        }}
                    >
                        {component.data.text}
                    </HeadingTag>
                );
            case 'paragraph':
                return (
                    <div
                        key={index} className={`revert-styles-childtags text-${component.data.alignment} ${component.data.dynamicClassCss}`}
                        style={{
                            border: component.data.border,
                            borderRadius: component.data.borderRadius,
                            paddingTop: component.data.paddingTop || component.data.paddingVertical,
                            paddingBottom: component.data.paddingBottom || component.data.paddingVertical,
                            paddingLeft: component.data.paddingLeft || component.data.paddingHorizontal,
                            paddingRight: component.data.paddingRight || component.data.paddingHorizontal,
                            marginTop: component.data.marginTop || component.data.marginVertical,
                            marginBottom: component.data.marginBottom || component.data.marginVertical,
                            marginLeft: component.data.marginLeft || component.data.marginHorizontal,
                            marginRight: component.data.marginRight || component.data.marginHorizontal
                        }}
                        dangerouslySetInnerHTML={{ __html: component.data.content }}
                    />
                );

            case 'image':
                const alignValue =
                    component.data.alignment === "left" ? "start" : component.data.alignment === "right" ? "end" : "center";
                return (
                    <div key={index} className={`text-${alignValue} ${component.data.dynamicClassCss}`}>
                        <a href={component.data.link || "#"} target={component.data.openInNewTab ? "_blank" : "_self"} rel="noopener noreferrer" style={{ display: "inline-block", cursor: component.data.link ? "pointer" : "", pointerEvents: component.data.link ? "auto" : "none" }}>
                            <img src={component.data.backgroundImageUrl || component.data.uploadedImageUrl || component.data.src} alt={component.data.alt} className="img-fluid rounded"
                                style={{
                                    width: component.data.width,
                                    border: component.data.border,
                                    borderRadius: component.data.borderRadius,
                                    paddingTop: component.data.paddingTop || component.data.paddingVertical,
                                    paddingBottom: component.data.paddingBottom || component.data.paddingVertical,
                                    paddingLeft: component.data.paddingLeft || component.data.paddingHorizontal,
                                    paddingRight: component.data.paddingRight || component.data.paddingHorizontal,
                                    marginTop: component.data.marginTop || component.data.marginVertical,
                                    marginBottom: component.data.marginBottom || component.data.marginVertical,
                                    marginLeft: component.data.marginLeft || component.data.marginHorizontal,
                                    marginRight: component.data.marginRight || component.data.marginHorizontal,
                                    //cursor: component.data.link ? "pointer" : ""
                                }} />
                        </a>
                    </div>);

            case 'video':
                const { videoType, videoId, autoplay, loop, muted, controls, playsInline, width, playerId, accountId, alignment, dynamicClassCss, height } = component?.data || {};
                const vimeoParams = new URLSearchParams({ autoplay: autoplay ? "1" : "0", loop: loop ? "1" : "0", muted: muted ? "1" : "0", controls: controls ? "1" : "0", playsinline: playsInline ? "1" : "0", }).toString();
                const UrlParams = new URLSearchParams({ autoplay: autoplay ? "1" : "0", loop: loop ? "1" : "0", mute: muted ? "1" : "0", controls: controls ? "1" : "0", playsinline: playsInline ? "1" : "0", }).toString();
                let videoElement = null;
                const isBrightcoveUrl = component.data.videoUrl?.includes("players.brightcove.net");
                const brightCoveParams = new URLSearchParams({ autoplay: autoplay ? "true" : "false", loop: loop ? "true" : "false", muted: muted ? "true" : "false", controls: controls ? "true" : "false", playsinline: playsInline ? "true" : "false", }).toString();
                console.log("vimeoParams", vimeoParams)
                console.log("UrlParams", UrlParams)
                console.log("brightCoveParams", brightCoveParams)
                const alignmentWrapper =
                    alignment === "center"
                        ? "text-center"
                        : alignment === "right"
                            ? "text-end"
                            : "text-start";

                if (component.data.youtubeEmbed) {
                    console.log("component.data.youtubeEmbed", component.data.youtubeEmbed)
                    videoElement = (
                        <iframe
                            src={`${component.data.youtubeEmbed}&${UrlParams}`}
                            width={width || "100%"}
                            height={`${height} !important`}
                        />
                    );
                } else if (isBrightcoveUrl) {
                    console.log("isBrightcoveUrl", isBrightcoveUrl)
                    videoElement = (
                        <iframe
                            src={`${component.data.videoUrl}&${vimeoParams}`}
                            width={width || "100%"}
                            height={`${height} !important`}
                        />
                    );

                } else if (component.data.videoUrl) {
                    console.log("component.data.videoUrl", component.data.videoUrl)
                    videoElement = (
                        <video
                            src={component.data.videoUrl}
                            autoPlay={!!autoplay}
                            muted={!!muted}
                            loop={!!loop}
                            playsInline={!!playsInline}
                            controls={!!controls}
                            width={width || "100%"}
                            height={`${height} !important`}
                        />
                    );
                } else if (videoId && videoType === "vimeo") {
                    videoElement = (
                        <iframe
                            src={`https://player.vimeo.com/video/${videoId}?${vimeoParams}`}
                            width={width || "100%"}
                            height={`${height} !important`}
                            allow="autoplay; fullscreen; picture-in-picture"
                            allowFullScreen
                        />
                    );
                } else if (videoId && videoType === "brightcove") {
                    videoElement = (
                        // <ReactPlayerLoader
                        //   id="playlist-player-id"
                        //   playerId={playerId || ""}
                        //   accountId={accountId || ""}
                        //   videoId={videoId}
                        //   options={{
                        //     responsive: true,
                        //     autoplay: !!autoplay,
                        //     muted: !!muted,
                        //     controls: !!controls,
                        //     playsinline: !!playsInline,
                        //     loop: !!loop
                        //   }}
                        // />
                        //             <iframe
                        // src={`https://players.brightcove.net/${accountId}/${playerId}_default/index.html?videoId=${videoId}&autoplay=true&muted=true&loop=true&playsinline=true&controls=true`}
                        //   width={width || "100%"}
                        //   height="315"
                        //   allow="autoplay; fullscreen; encrypted-media"
                        //   allowFullScreen
                        // />
                        <iframe
                            src={`https://players.brightcove.net/${accountId}/${playerId}_default/index.html?videoId=${videoId}`}
                            width={width || "100%"}
                            height={`${height} !important`}
                        />
                    );
                } else if (component.data.uploadVideo) {
                    console.log("component.data.uploadVideo", component.data.uploadVideo)
                    videoElement = (
                        <video
                            src={`${component.data.uploadVideo}`}
                            width={width || "100%"}
                            height={`${height} !important`}
                            autoPlay={!!autoplay}
                            muted={!!muted}
                            loop={!!loop}
                            playsInline={!!playsInline}
                            controls={!!controls}
                        />
                    );

                }

                return (
                    <div className={`${alignmentWrapper || ""} ${dynamicClassCss || ""}`}>
                        {videoElement}
                    </div>
                );

            case 'button':
                const buttonClasses = {
                    primary: 'btn btn-primary',
                    secondary: 'btn btn-secondary',
                    outline: 'btn btn-outline-primary'
                };

                const sizeClasses = {
                    small: 'btn-sm',
                    medium: '',
                    large: 'btn-lg'
                };

                return (
                    <div key={index} className={`text-${component.data.alignment} ${component.data.dynamicClassCss}`}>
                        <a href={component.data.href} className={`btn ${buttonClasses[component.data.style]} ${sizeClasses[component.data.size]}`}
                            style={{
                                textDecoration: "none",
                                background: component.data.backgroundColor,
                                color: component.data.color || "white",
                                border: component.data.border,
                                width: component.data.width,
                                borderRadius: component.data.borderRadius,
                                paddingTop: component.data.paddingTop || component.data.paddingVertical,
                                paddingBottom: component.data.paddingBottom || component.data.paddingVertical,
                                paddingLeft: component.data.paddingLeft || component.data.paddingHorizontal,
                                paddingRight: component.data.paddingRight || component.data.paddingHorizontal,
                                marginTop: component.data.marginTop || component.data.marginVertical,
                                marginBottom: component.data.marginBottom || component.data.marginVertical,
                                marginLeft: component.data.marginLeft || component.data.marginHorizontal,
                                marginRight: component.data.marginRight || component.data.marginHorizontal
                            }}>{component.data.text}
                        </a>
                    </div>
                );
            case 'accordion':
                const accordionContent = {
                    contentId: component.id,
                    attributes: {
                        articleRendering: '',
                        class: '',
                    },
                    title: component.data.title,
                    body: component.data.body,
                    expanded: component.data.defaultExpand
                };
                return (
                    <div className={`${component.data.dynamicClassCss || ''}`} style={{
                        width: component.data.width, border: component.data.border,
                        borderRadius: component.data.borderRadius,
                        paddingTop: component.data.paddingTop || component.data.paddingVertical,
                        paddingBottom: component.data.paddingBottom || component.data.paddingVertical,
                        paddingLeft: component.data.paddingLeft || component.data.paddingHorizontal,
                        paddingRight: component.data.paddingRight || component.data.paddingHorizontal,
                        marginTop: component.data.marginTop || component.data.marginVertical,
                        marginBottom: component.data.marginBottom || component.data.marginVertical,
                        marginLeft: component.data.marginLeft || component.data.marginHorizontal,
                        marginRight: component.data.marginRight || component.data.marginHorizontal
                    }}>
                        <Accordion articleObj={accordionContent} />
                    </div>
                );

            case 'htmlRawContent':
                const htmlRawContent = {
                    contentId: component.id,
                    attributes: {
                        articleRendering: '',
                        class: '',
                        htmlRawContent: component.data.htmlRawContent,
                    },

                };
                return (
                    <div style={{
                        width: component.data.width, border: component.data.border,
                        borderRadius: component.data.borderRadius,
                        paddingTop: component.data.paddingTop || component.data.paddingVertical,
                        paddingBottom: component.data.paddingBottom || component.data.paddingVertical,
                        paddingLeft: component.data.paddingLeft || component.data.paddingHorizontal,
                        paddingRight: component.data.paddingRight || component.data.paddingHorizontal,
                        marginTop: component.data.marginTop || component.data.marginVertical,
                        marginBottom: component.data.marginBottom || component.data.marginVertical,
                        marginLeft: component.data.marginLeft || component.data.marginHorizontal,
                        marginRight: component.data.marginRight || component.data.marginHorizontal
                    }}>
                        <HtmlRawContainerArticle articleObj={htmlRawContent} />
                    </div>
                );

            case 'column-container': {
                const paddingClasses = {
                    none: '',
                    small: 'p-2',
                    medium: 'p-4',
                    large: 'p-5'
                };

                const gapClasses = {
                    none: 'g-0',
                    small: 'g-2',
                    medium: 'g-3',
                    large: 'g-4'
                };

                const colCount = component.data.noOfColumns || 1;
                const tabTargetId = component.data.tabTargetId

                const groupedChildren = Array.from({ length: colCount }, (_, i) =>
                    component.children?.filter((child) => child.columnIndex === i || child.data?.columnIndex === i) || []);

                const isVisible = activeTabId === component.data.tabTargetId

                return tabTargetId ? (
                    <div style={{ inset: 0, transform: isVisible ? 'translateX(0%) scale(1)' : 'translateX(100%) scale(0.96)', opacity: isVisible ? 1 : 0, transition: 'transform 0.5s cubic-bezier(0.4,0,0.2,1), opacity 0.4s', pointerEvents: isVisible ? 'auto' : 'none', height: isVisible ? 'auto' : 0 }}>
                        <div key={index}
                            className={`${paddingClasses[component.data?.padding || '']} my-1`}
                            style={{
                                position: "relative",
                                backgroundColor: component.data.backgroundColor || '',
                                backgroundSize: "cover",
                                backgroundImage: `url(${component.data.backgroundImageUrl || component.data.uploadedImageUrl})`,
                                border: component.data.border,
                                width: component.data.width,
                                borderRadius: component.data.borderRadius,
                                minHeight: component.data.height ? `${component.data.height}` : '60vh',
                                paddingTop: component.data.paddingTop || component.data.paddingVertical,
                                paddingBottom: component.data.paddingBottom || component.data.paddingVertical,
                                paddingLeft: component.data.paddingLeft || component.data.paddingHorizontal,
                                paddingRight: component.data.paddingRight || component.data.paddingHorizontal,
                                marginTop: component.data.marginTop || component.data.marginVertical,
                                marginBottom: component.data.marginBottom || component.data.marginVertical,
                                marginLeft: component.data.marginLeft || component.data.marginHorizontal,
                                marginRight: component.data.marginRight || component.data.marginHorizontal
                            }}>
                            {(component.data.backgroundVideoUrl || component.data.uploadBackgroundVideoUrl) && (() => {
                                const url = component.data.backgroundVideoUrl || component.data.uploadBackgroundVideoUrl;

                                const isMp4 = url.endsWith('.mp4');
                                const isYoutube = url.includes('youtube.com') || url.includes('youtu.be');
                                const isBrightcove = url.includes('brightcove');

                                // MP4 Video
                                if (isMp4) {
                                    return (
                                        <video autoPlay muted loop playsInline
                                            style={{ position: "absolute", inset: 0, width: `${component.data.videoWidth || "100%"}`, height: `${component.data.videoHeight || "100%"}`, objectFit: "cover", zIndex: 0, }}>
                                            <source src={url} type="video/mp4" />
                                        </video>
                                    );
                                }

                                if (isYoutube || isBrightcove) {
                                    return (
                                        <div
                                            style={{ position: "absolute", inset: 0, zIndex: 0, overflow: "hidden", }} >
                                            <iframe
                                                src={`${url}${url.includes('?') ? '&' : '?'}autoplay=1&mute=1&loop=1&playsinline=1`}
                                                allow="autoplay; encrypted-media; picture-in-picture"
                                                style={{ width: `${component.data.videoWidth || "100%"}`, height: `${component.data.videoHeight || "100%"}`, border: "none", pointerEvents: "none", transform: "scale(1.2)", }} /> </div>
                                    );
                                } return null;
                            })()}

                            <div className={`row g-0`} style={{ position: 'relative', zIndex: 2, display: 'flex' }}>
                                {groupedChildren.map((colChildren, colIndex) => {
                                    const colStyles = component.children[colIndex]?.columnStyles || {}
                                    return (
                                        <div key={colIndex} className={`${colStyles?.dynamicClassCss || ''}`}
                                            style={{
                                                backgroundColor: [colStyles.Col_backgroundColor], backgroundImage: `url(${[colStyles.Col_backgroundImageUrl || colStyles.Col_uploadedImageUrl || ""]})`, backgroundSize: "cover",
                                                border: [colStyles.Col_border], borderRadius: [colStyles.Col_borderRadius],
                                                borderRight: "5px solid #f5f5f9",
                                                paddingTop: [colStyles.Col_paddingTop], paddingBottom: [colStyles.Col_paddingBottom],
                                                paddingLeft: [colStyles.Col_paddingLeft], paddingRight: [colStyles.Col_paddingRight],
                                                marginTop: [colStyles.Col_marginTop], marginBottom: [colStyles.Col_marginBottom],
                                                marginLeft: [colStyles.Col_marginLeft], marginRight: [colStyles.Col_marginRight],
                                                uploadedImageUrl: [colStyles.Col_uploadedImageUrl || ""], minHeight: [colStyles.Col_height || '60vh'],
                                                flex: colStyles.Col_width ? `0 0 ${colStyles.Col_width}` : '1 1 0',
                                                maxWidth: colStyles.Col_width || '100%',

                                            }}>
                                            {colStyles.Col_backgroundVideoUrl || colStyles.Col_uploadBackgroundVideoUrl && (() => {
                                                const url = colStyles.Col_backgroundVideoUrl || colStyles.Col_uploadBackgroundVideoUrl;

                                                const isMp4 = url.endsWith('.mp4');
                                                const isYoutube = url.includes('youtube.com') || url.includes('youtu.be');
                                                const isBrightcove = url.includes('brightcove');

                                                // MP4 Video
                                                if (isMp4) {
                                                    return (
                                                        <video autoPlay muted loop playsInline
                                                            style={{ position: "absolute", inset: 0, width: `${colStyles.Col_videoWidth || "100%"}`, height: `${colStyles.Col_videoHeight || "100%"}`, objectFit: "cover", zIndex: 0, }}>
                                                            <source src={url} type="video/mp4" />
                                                        </video>
                                                    );
                                                }

                                                if (isYoutube || isBrightcove) {
                                                    return (
                                                        <div
                                                            style={{ position: "absolute", inset: 0, zIndex: 0, overflow: "hidden", }} >
                                                            <iframe
                                                                src={`${url}${url.includes('?') ? '&' : '?'}autoplay=1&mute=1&loop=1&playsinline=1`}
                                                                allow="autoplay; encrypted-media; picture-in-picture"
                                                                style={{ width: `${colStyles.Col_videoWidth || "100%"}`, height: `${colStyles.Col_videoHeight || "100%"}`, border: "none", pointerEvents: "none", transform: "scale(1.2)", }} /> </div>
                                                    );
                                                } return null;
                                            })()}
                                            <div style={{ position: 'relative', zIndex: 2, height: '100%' }}>
                                                {colChildren.map((child, i) =>
                                                    child.children ? child.children.map((c, j) => renderComponent(c, j)) : renderComponent(child, i)
                                                )}
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                ) : (
                    <div key={index}
                        className={`${paddingClasses[component.data?.padding || '']} my-1`}
                        style={{
                            position: "relative",
                            backgroundColor: component.data.backgroundColor || '',
                            backgroundSize: "cover",
                            backgroundImage: `url(${component.data.backgroundImageUrl || component.data.uploadedImageUrl})`,
                            border: component.data.border,
                            width: component.data.width,
                            borderRadius: component.data.borderRadius,
                            minHeight: component.data.height ? `${component.data.height}` : '60vh',
                            paddingTop: component.data.paddingTop || component.data.paddingVertical,
                            paddingBottom: component.data.paddingBottom || component.data.paddingVertical,
                            paddingLeft: component.data.paddingLeft || component.data.paddingHorizontal,
                            paddingRight: component.data.paddingRight || component.data.paddingHorizontal,
                            marginTop: component.data.marginTop || component.data.marginVertical,
                            marginBottom: component.data.marginBottom || component.data.marginVertical,
                            marginLeft: component.data.marginLeft || component.data.marginHorizontal,
                            marginRight: component.data.marginRight || component.data.marginHorizontal
                        }}>
                        {(component.data.backgroundVideoUrl || component.data.uploadBackgroundVideoUrl) && (() => {
                            const url = component.data.backgroundVideoUrl || component.data.uploadBackgroundVideoUrl;

                            const isMp4 = url.endsWith('.mp4');
                            const isYoutube = url.includes('youtube.com') || url.includes('youtu.be');
                            const isBrightcove = url.includes('brightcove');

                            // MP4 Video
                            if (isMp4) {
                                return (
                                    <video autoPlay muted loop playsInline
                                        style={{ position: "absolute", inset: 0, width: `${component.data.videoWidth || "100%"}`, height: `${component.data.videoHeight || "100%"}`, objectFit: "cover", zIndex: 0, }}>
                                        <source src={url} type="video/mp4" />
                                    </video>
                                );
                            }

                            if (isYoutube || isBrightcove) {
                                return (
                                    <div
                                        style={{ position: "absolute", inset: 0, zIndex: 0, overflow: "hidden", }} >
                                        <iframe
                                            src={`${url}${url.includes('?') ? '&' : '?'}autoplay=1&mute=1&loop=1&playsinline=1`}
                                            allow="autoplay; encrypted-media; picture-in-picture"
                                            style={{ width: `${component.data.videoWidth || "100%"}`, height: `${component.data.videoHeight || "100%"}`, border: "none", pointerEvents: "none", transform: "scale(1.2)", }} /> </div>
                                );
                            } return null;
                        })()}

                        <div className={`row g-0`} style={{ position: 'relative', zIndex: 2, display: 'flex' }}>
                            {groupedChildren.map((colChildren, colIndex) => {
                                const colStyles = component.children[colIndex]?.columnStyles || {}
                                return (
                                    <div key={colIndex} className={`${colStyles?.dynamicClassCss || ''}`}
                                        style={{
                                            backgroundColor: [colStyles.Col_backgroundColor], backgroundImage: `url(${[colStyles.Col_backgroundImageUrl || colStyles.Col_uploadedImageUrl || ""]})`, backgroundSize: "cover",
                                            border: [colStyles.Col_border], borderRadius: [colStyles.Col_borderRadius],
                                            borderRight: "5px solid #f5f5f9",
                                            paddingTop: [colStyles.Col_paddingTop], paddingBottom: [colStyles.Col_paddingBottom],
                                            paddingLeft: [colStyles.Col_paddingLeft], paddingRight: [colStyles.Col_paddingRight],
                                            marginTop: [colStyles.Col_marginTop], marginBottom: [colStyles.Col_marginBottom],
                                            marginLeft: [colStyles.Col_marginLeft], marginRight: [colStyles.Col_marginRight],
                                            uploadedImageUrl: [colStyles.Col_uploadedImageUrl || ""], minHeight: [colStyles.Col_height || '60vh'],
                                            flex: colStyles.Col_width ? `0 0 ${colStyles.Col_width}` : '1 1 0',
                                            maxWidth: colStyles.Col_width || '100%',

                                        }}>
                                        {colStyles.Col_backgroundVideoUrl || colStyles.Col_uploadBackgroundVideoUrl && (() => {
                                            const url = colStyles.Col_backgroundVideoUrl || colStyles.Col_uploadBackgroundVideoUrl;

                                            const isMp4 = url.endsWith('.mp4');
                                            const isYoutube = url.includes('youtube.com') || url.includes('youtu.be');
                                            const isBrightcove = url.includes('brightcove');

                                            // MP4 Video
                                            if (isMp4) {
                                                return (
                                                    <video autoPlay muted loop playsInline
                                                        style={{ position: "absolute", inset: 0, width: `${colStyles.Col_videoWidth || "100%"}`, height: `${colStyles.Col_videoHeight || "100%"}`, objectFit: "cover", zIndex: 0, }}>
                                                        <source src={url} type="video/mp4" />
                                                    </video>
                                                );
                                            }

                                            if (isYoutube || isBrightcove) {
                                                return (
                                                    <div
                                                        style={{ position: "absolute", inset: 0, zIndex: 0, overflow: "hidden", }} >
                                                        <iframe
                                                            src={`${url}${url.includes('?') ? '&' : '?'}autoplay=1&mute=1&loop=1&playsinline=1`}
                                                            allow="autoplay; encrypted-media; picture-in-picture"
                                                            style={{ width: `${colStyles.Col_videoWidth || "100%"}`, height: `${colStyles.Col_videoHeight || "100%"}`, border: "none", pointerEvents: "none", transform: "scale(1.2)", }} /> </div>
                                                );
                                            } return null;
                                        })()}
                                        <div style={{ position: 'relative', zIndex: 2, height: '100%' }}>
                                            {colChildren.map((child, i) =>
                                                child.children ? child.children.map((c, j) => renderComponent(c, j)) : renderComponent(child, i)
                                            )}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                )
            }

            case 'slider':
                return (
                    <div className={`${component.data.attributes.articleContainerRendering} ${component.data.attributes.class} row g-0 relative w-full overflow-visible`}
                        style={{ backgroundColor: component?.data?.attributes?.backgroundColor || "transparent" }}>
                        {component?.data && Object.keys(component.data).length > 0 && (
                            <CustomSlider containerObject={component.data} />
                        )}
                    </div>
                )

            case "tabs": {
                const tabs = component.data.tabNames;
                const tabId = component.data.tabId;
                const [activeTab, setActiveTab] = useState(0);

                useEffect(() => {
                    if (!activeTabId && tabId?.length) {
                        setActiveTabId(tabId[0]);
                    }
                }, [tabId]);


                const handleTabClick = (index) => {
                    setActiveTab(index);
                    setActiveTabId(tabId[index]);
                };


                return (
                    <div className={`col-12 d-flex text-${component.data.textAlignment || ''} gap-4`}>

                        {component.data.optionalText && (
                            <div
                                className={`fw-semibold ${component.data.textdynamicClassCss || ""}`}
                                style={{
                                    width: component.data.textWidth || "40%",
                                    color: component.data.textColor || "white",
                                    backgroundColor: component.data.textBackgroundColor,
                                    backgroundImage: component.data.textBackgroundImageUrl
                                        ? `url(${component.data.textBackgroundImageUrl})`
                                        : undefined,
                                }}
                            >
                                {component.data.optionalText}
                            </div>
                        )}
                        <ul className="w-100 justify-content-around nav nav-underline gap-4 mb-0 flex-row "
                            style={{
                                border: component?.data?.tabBorder,
                                borderRadius: component?.data?.tabBorderRadius,
                                paddingTop: component.data.paddingTop || component.data.paddingVertical,
                                paddingBottom: component.data.paddingBottom || component.data.paddingVertical,
                                paddingLeft: component.data.paddingLeft || component.data.paddingHorizontal,
                                paddingRight: component.data.paddingRight || component.data.paddingHorizontal,
                                marginTop: component.data.marginTop || component.data.marginVertical,
                                marginBottom: component.data.marginBottom || component.data.marginVertical,
                                marginLeft: component.data.marginLeft || component.data.marginHorizontal,
                                marginRight: component.data.marginRight || component.data.marginHorizontal

                            }}>

                            {tabs && tabs.map((label, index) => (
                                <li className="nav-item" key={tabId[index]}>
                                    <button
                                        type="button"
                                        className={`nav-link ${component.data.dynamicClassCss} ${activeTab === index ? 'active' : ''}`}
                                        onClick={() => handleTabClick(index)}
                                        style={{ color: activeTab === index ? component?.data?.tabsColor : "#6c757d" }}
                                    >
                                        {label}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                );
            }
            default:
                return null;
        }
    };

    return (
        <div
            data-cont-id={containerObject.contentId}
            data-zone={dataZone}
            data-page-id={contentId}
            data-template-name={templateName}
            className="vast-plugin-content row g-0 cb-html-content">
            {/* {containerObject?.attributes?.htmlRawContent && (
                <span dangerouslySetInnerHTML={{ __html: containerObject.attributes.htmlRawContent }}></span>
            )} */}
            {parsedData && parsedData?.components?.map(renderComponent)}
        </div>
    );
};

export default AdvancedHtmlEditor;
